// extracted by mini-css-extract-plugin
export default {"Container":"BranchActionMenu-module__Container--_UM3r","ActionButtonGroup":"BranchActionMenu-module__ActionButtonGroup--d7CgA"};